import React from 'react';
import CustomCheckbox from 'components/Additional/CustomCheckbox/CustomCheckbox';

import styles from './Consent.module.css';

const Consent = ({ customClass, value, onChange }) => {
	return (
		<div className={customClass}>
			<div className={styles.consent_container}>
				<div className={styles.consent_checkbox_container}>
					<CustomCheckbox
						id="consent_checkbox"
						value={value}
						onChange={onChange}
					/>
				</div>
				<div className={styles.consent_text_container}>
					<p className={styles.consent_text}>
						By checking this box, you are providing express consent
						to receive communications from Security First Insurance
						Company about your insurance quote and related services.
						These communications may include emails, phone calls, or
						text messages. Message and data rates may apply. You may
						opt out at any time. You also acknowledge that you have
						read and understand our Privacy Policy and Terms of Use.
					</p>
				</div>
			</div>
		</div>
	);
};

export default Consent;
